export const productName = "Graze";
